import { IconClock, IconShieldCheck } from '@tabler/icons-react'

export default function DataRetentionSection() {
  return (
    <section id="disclaimer" className="bg-white py-12">
      <div className="max-w-5xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <div className="bg-gradient-to-br from-orange-50 to-orange-100/50 rounded-2xl p-6 relative overflow-hidden">
            <div className="absolute top-0 right-0 w-32 h-32 bg-orange-200/30 rounded-full blur-2xl"></div>
            <div className="relative">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-white rounded-xl flex items-center justify-center shadow-sm">
                  <IconClock size={20} className="text-orange-500" />
                </div>
                <h3 className="text-lg font-bold text-gray-900">信息保存说明</h3>
              </div>
              <div className="space-y-3">
                <p className="text-sm text-gray-700">
                  查询结果将被有限期保存，最长不超过{' '}
                  <span className="inline-flex items-center px-2 py-0.5 bg-orange-500 text-white text-xs font-medium rounded">
                    30 天
                  </span>
                </p>
                <p className="text-sm text-gray-600">仅供用户本人或其授权对象查看</p>
                <p className="text-xs text-gray-400">服务期结束后自动清除，不用于分析、画像或其他用途</p>
              </div>
            </div>
          </div>

          <div className="bg-gray-50 rounded-2xl p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 bg-white rounded-xl flex items-center justify-center shadow-sm">
                <IconShieldCheck size={20} className="text-gray-600" />
              </div>
              <h3 className="text-lg font-bold text-gray-900">使用说明</h3>
            </div>
            <div className="space-y-3">
              <p className="text-sm text-gray-700">平台仅负责信息的查询与展示</p>
              <p className="text-sm text-gray-600">用户应自行理解并使用查询结果</p>
              <div className="pt-2 border-t border-gray-200">
                <p className="text-xs text-gray-400">基于查询结果所产生的任何判断、决策或行为，均由用户自行承担责任</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
